import Vue from "vue";

Vue.component("construction-service-item-metadata-editor", {
    props: ["contextId"],
    data() {
        return {
            id: 0,
            loading: false,
            showSidebar: false,
            numberings: [],
            numbering: null,
            numberingLabel: '',
            noteCode1997s: [],
            noteCode1997: null,
            noteCode1997Label: '',
            noteCodeGPA113s: [],
            noteCodeGPA113: null,
            noteCodeGPA113Label: '',
            furtherCharacterizations: [],
            furtherCharacterization: null,
            furtherCharacterizationLabel: '',
            overlay: false,
            fullheight: true,
            fullwidth: false,
            right: true,
            showFormModal: false,
            counter: 0,
            currentId: this.contextId
        };
    },
    methods: {
        initialize(constructionServiceItemId) {
            const self = this;
            self.loading = true;
            self.id = constructionServiceItemId;

            self.$services.constructionServiceItemMetadatas.getList({
                language: window.currentLanguage,
                constructionServiceItemId: constructionServiceItemId
            }).then((data) => {
                self.numberings = data.numberings;
                self.numbering = data.numbering;
                self.numberingLabel = data.numberingLabel;
                self.noteCode1997s = data.noteCode1997s;
                self.noteCode1997 = data.noteCode1997;
                self.noteCode1997Label = data.noteCode1997Label;
                self.noteCodeGPA113s = data.noteCodeGPA113s;
                self.noteCodeGPA113 = data.noteCodeGPA113;
                self.noteCodeGPA113Label = data.noteCodeGPA113Label;
                self.noteCodeGPA113s = data.noteCodeGPA113s;
                self.noteCodeGPA113 = data.noteCodeGPA113;
                self.noteCodeGPA113Label = data.noteCodeGPA113Label;
                self.furtherCharacterizations = data.furtherCharacterizations;
                self.furtherCharacterization = data.furtherCharacterization;
                self.furtherCharacterizationLabel = data.furtherCharacterizationLabel;

                self.showSidebar = true;
                self.loading = false;
            });
        },
        save() {
            const self = this;

            let metadatas = []

            if (self.numbering != null && self.numbering > 0) {
                metadatas.push(self.numbering);
            }

            if (self.noteCode1997 != null && self.noteCode1997 > 0) {
                metadatas.push(self.noteCode1997);
            }

            if (self.noteCodeGPA113 != null && self.noteCodeGPA113 > 0) {
                metadatas.push(self.noteCodeGPA113);
            }

            if (self.noteCodeGPA113 != null && self.noteCodeGPA113 > 0) {
                metadatas.push(self.noteCodeGPA113);
            }

            if (self.furtherCharacterization != null && self.furtherCharacterization > 0) {
                metadatas.push(self.furtherCharacterization);
            }

            self.$services.constructionServiceItemMetadatas.save({
                constructionServiceItemId: this.id,
                metadataIds: metadatas
            }).then((data) => {
                if (data) {
                    this.showSidebar = false;
                    this.$buefy.snackbar.open(`The construction service item metadata was successfully stored`);
                }
                else {
                    this.$buefy.snackbar.open(`The construction service item metadata was not stored`);
                }
            });

        },
        discard() {
            this.showSidebar = false;
        },
        close() {
            this.showSidebar = false;
        },
        editConstructionServiceItem() {
            const self = this;

            self.counter += 1;
            self.currentId = self.id + '|0|' + self.counter;

            self.$emit('update:contextId', self.currentId);
        }
    },
    template: `
		<b-sidebar
            type="is-light"
            scroll="keep"
            :fullheight="fullheight"
            :fullwidth="fullwidth"                
            :overlay="overlay"
            :right="right"
            v-model="showSidebar">
            <template v-if="loading"><loading></loading></template>
            <template v-else>				                    
                <header class="modal-card-head">                            
                    <div class="buttons">
                        <b-button type="is-primary" icon-left="edit" @click="editConstructionServiceItem">Edit Basic information</b-button>
                        <b-button type="is-secondary" icon-right="arrow-right" @click="close"></b-button>
                    </div>
		        </header>
		        <section class="modal-card-body">                                                					    
                    <b-field class="mb-0 p-0 metadata-control" :label="numberingLabel">
						<b-select v-model="numbering">
							<option
								v-for="option in numberings"
								:value="option.id"
								:key="option.id">
								{{ option.name }}
							</option>
						</b-select>
					</b-field>
					<b-field class="mb-0 p-0 metadata-control" :label="noteCode1997Label">
						<b-select v-model="noteCode1997">
							<option
								v-for="option in noteCode1997s"
								:value="option.id"
								:key="option.id">
								{{ option.name }}
							</option>
						</b-select>
					</b-field>
					<b-field class="mb-0 p-0 metadata-control" :label="noteCodeGPA113Label">
						<b-select v-model="noteCodeGPA113">
							<option
								v-for="option in noteCodeGPA113s"
								:value="option.id"
								:key="option.id">
								{{ option.name }}
							</option>
						</b-select>
					</b-field>
					<b-field class="mb-0 p-0 metadata-control" :label="furtherCharacterizationLabel">
						<b-select v-model="furtherCharacterization">
							<option
								v-for="option in furtherCharacterizations"
								:value="option.id"
								:key="option.id">
								{{ option.name }}
							</option>
						</b-select>
					</b-field>
				</section>
                <footer class="modal-card-foot buttons">
                    <div class="buttons">
                        <b-button type="is-primary" @click="save">Save</b-button>
                        <b-button type="is-danger" @click="discard">Discard</b-button>
                    </div>
                </footer>
            </template>
        </b-sidebar>        
	`
});